import axios from 'axios';
import { camelCase } from 'lodash';
import { deepMapKeys } from '../utils/commonUtil';
import type { Axios, CreateAxiosDefaults } from 'axios';

export function buildAxiosClient(
  config: CreateAxiosDefaults = {},
  snakeCaseResponse = false,
): Axios {
  const client = axios.create({
    headers: {
      'X-CSRF-Token': csrfToken() ?? '',
    },
    timeout: 60000,
    ...config,
  });

  if (!snakeCaseResponse) {
    client.interceptors.response.use(res => {
      if (res.data) res.data = deepMapKeys(res.data, key => camelCase(key));
      return res;
    });
  }

  return client;
}

function csrfToken(): string | null {
  const token = document.querySelector('meta[name="csrf-token"]');
  if (token && token instanceof window.HTMLMetaElement) {
    return token.content;
  }
  return null;
}
